import { Property } from 'csstype'

import {
  Margin,
  Padding,
  TextEntry,
  TextStyle,
} from '@thg-commerce/gravity-theme'

export interface ProductDescriptionAccordionThemeInterface {
  defaultItemsOpen: number
  details: {
    backgroundColor?: Property.Color
    title: {
      padding: Padding
    }
    item: {
      display: string
      direction?: string
      padding: Padding
      margin?: Margin
    }
    showProductDetailsAsList: boolean
  }
  container: {
    padding: Padding
  }
  content: {
    textStyling: {
      entry: TextEntry
      style: TextStyle
    }
    margin: {
      p: Margin
      li: Margin
    }
  }
  deliveryAndReturnsInfo: {
    margin: Margin
  }
}

export const theme: ProductDescriptionAccordionThemeInterface = {
  defaultItemsOpen: 1,
  details: {
    title: {
      padding: {
        top: 1,
        right: 2,
        bottom: 1,
        left: 2,
      },
    },
    item: {
      display: 'flex',
      direction: 'row',
      padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 2,
      },
    },
    showProductDetailsAsList: false,
  },
  container: {
    padding: {
      top: 2,
      right: 1,
      bottom: 3,
      left: 1,
    },
  },
  content: {
    textStyling: {
      entry: 'bodyText',
      style: 'default',
    },
    margin: {
      p: {
        top: 1,
        bottom: 1.5,
        left: 0,
        right: 0,
      },
      li: {
        top: 1,
        bottom: 0,
        left: 0,
        right: 0,
      },
    },
  },
  deliveryAndReturnsInfo: {
    margin: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 2,
    },
  },
}
